module.exports = __webpack_public_path__ + "static/media/itsilesia.bba8c03f.png";